import { render, staticRenderFns } from "./mingxi.vue?vue&type=template&id=fb86df8c&scoped=true"
import script from "./mingxi.vue?vue&type=script&lang=js"
export * from "./mingxi.vue?vue&type=script&lang=js"
import style0 from "./mingxi.vue?vue&type=style&index=0&id=fb86df8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb86df8c",
  null
  
)

export default component.exports